var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMessage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "message-icon-path",
    d: "M5.25 8.25c0-.415.336-.75.75-.75s.75.335.75.75c0 .413-.336.75-.75.75s-.75-.337-.75-.75zM9 7.5c-.414 0-.75.335-.75.75 0 .413.336.75.75.75s.75-.337.75-.75c0-.415-.336-.75-.75-.75zm3 0c-.414 0-.75.335-.75.75 0 .413.336.75.75.75s.75-.337.75-.75c0-.415-.336-.75-.75-.75zm2.924 1.72c-.38 2.441-2.348 4.465-4.784 4.922-1.177.222-2.376.095-3.463-.365-.308-.13-.627-.197-.94-.197-.142 0-.283.014-.422.042l-2.11.421.423-2.113c.089-.438.035-.908-.155-1.357-.46-1.088-.587-2.285-.365-3.463.456-2.437 2.48-4.404 4.921-4.784 1.943-.302 3.842.31 5.213 1.68 1.372 1.372 1.985 3.273 1.682 5.215zm-.62-6.274C12.59 1.233 10.22.47 7.798.843c-3.058.477-5.593 2.94-6.165 5.99-.276 1.469-.117 2.964.458 4.324.073.173.096.335.067.48l-.643 3.215c-.05.246.027.5.205.678.142.142.333.22.53.22.05 0 .098-.005.147-.015l3.213-.643c.184-.035.363.017.482.066 1.361.576 2.857.734 4.324.459 3.05-.573 5.514-3.108 5.99-6.165.377-2.42-.389-4.792-2.102-6.506z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message.b01bf5f5.svg";
export { ForwardRef as ReactComponent };